import { render, staticRenderFns } from "./ObservatoryUsageGuide.vue?vue&type=template&id=3c96e998&scoped=true&"
import script from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
export * from "./ObservatoryUsageGuide.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryUsageGuide.vue?vue&type=style&index=0&id=3c96e998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96e998",
  null
  
)

export default component.exports